import { render, staticRenderFns } from "./Statistik.vue?vue&type=template&id=4f3333fa&"
import script from "./Statistik.vue?vue&type=script&lang=js&"
export * from "./Statistik.vue?vue&type=script&lang=js&"
import style0 from "./Statistik.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports